import { render, staticRenderFns } from "./MyPageDetail.vue?vue&type=template&id=71f50eb9&scoped=true"
import script from "./MyPageDetail.vue?vue&type=script&lang=js"
export * from "./MyPageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f50eb9",
  null
  
)

export default component.exports